import {createContext, useContext} from 'react'

const AiContext = createContext()

export const AiProvider = AiContext.Provider
export const useAiContext = () => useContext(AiContext)
